import React, { useEffect, useState } from "react";
import ActionMenu from "../../../components/header/ActionMenu";
import Menu from "../../../components/header/Menu";
import Header from "../../../components/header/Header";
import ContentMenu from "../../../components/header/ContentMenu";
import { Box, Drawer, Slide } from "@mui/material";
import DesignMenu from "../../../components/header//DesignMenu";
import PopDesignMenu from "../../../components/header/PopupDesignMenu";
import ColorPicker from "../../../components/header/ColorPicker";
import CustomizeHeader from "../../../components/header/CustomizeHeader";
import HeaderColorMenu from "../../../components/header/HeaderColorMenu";
import MobileHeader from "../../../components/header/MobileHeader";
import EditHeader from "../../../components/header/EditHeader";
import BoxShadowGenerator from "../../../components/header/BoxShadowGenerator";
import data from "./data.json";
import LogoMenu from "../../../components/header/LogoMenu";
import "./header.css";
import { apiURL } from "../../../config/default";
import axios from "axios";
import setAuthHeader from "../../../utils/setAuthHeader";

const CustomHeader = () => {
  const [headerItemData, setHeaderItemData] = useState(data[0]);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const getCustomHeader = async () => {
      try {
        const token = localStorage.getItem("token");
        if (token) {
          setAuthHeader(token);
        }
        const response = await axios.get(`${apiURL}admin/layout`);

        const apiData = response.data;
        if (apiData[0].customHeader.customTopbar) {
          setHeaderItemData(apiData[0]);
        }
        // console.log({ headerItemData });
      } catch (error) {
        console.log({ error });
      }
    };
    getCustomHeader();
  }, []);

  const [editItem, setEditItem] = useState({
    open: false,
    index: null,
    item: "",
    key: null,
    prevItem: "",
  });

  const toggleDrawer = (
    open,
    index = null,
    item = null,
    key = null,
    prevItem = null
  ) => {
    setEditItem({
      open,
      index,
      item,
      prevItem,
      key,
    });
  };

  const handleSave = (itemType, key, value, main = "") => {
    const updatedHeaderItemData = {
      ...headerItemData,
    };

    const getHeaderType = () => {
      if (editItem.index === 0) return "customTopbar";
      if (editItem.index === 1) return "customHeader";
      return "customNavbar";
    };

    const getMobileHeaderType = () => {
      return editItem.index === 0 ? "mobileTopbar" : "mobileHeader";
    };

    const updateNullIndex = () => {
      const { customHeader } = updatedHeaderItemData;
      const { prevItem } = editItem;

      if (prevItem === "search" || prevItem === "items") {
        if (isMobile) {
          const objectKey =
            prevItem === "search" ? "mobileSearch" : "mobileItems";

          customHeader.customHeader.customizeHeader[objectKey][key] = value;
        } else {
          customHeader.customHeader.customizeHeader[prevItem][key] = value;
        }
      } else {
        const logoType = isMobile ? "mobileLogo" : "logo";
        customHeader.customHeader[logoType][key] = value;
      }
    };

    const updateBackgroundColor = () => {
      const headerType = getHeaderType();
      updatedHeaderItemData.customHeader[headerType].backgroundColor = value;
    };

    const updateTestCase = () => {
      const headerType = isMobile ? getMobileHeaderType() : getHeaderType();
      updatedHeaderItemData.customHeader[headerType][key] = value;
    };

    const updateDefault = () => {
      const headerType = isMobile ? "mobileTopbar" : "customTopbar";
      updatedHeaderItemData.customHeader[headerType].links[editItem.index][
        itemType
      ][key] = value;
    };

    // Main logic flow
    if (editItem.index === null) {
      updateNullIndex();
    } else if (key === null) {
      if (itemType === "bgColor") {
        updateBackgroundColor();
      }
      const headerType = isMobile ? "mobileTopbar" : "customTopbar";
      updatedHeaderItemData.customHeader[headerType].links[editItem.index][
        itemType
      ] = value;
    } else if (itemType === "test" || main === "test") {
      updateTestCase();
    } else {
      updateDefault();
    }

    setHeaderItemData({ ...updatedHeaderItemData });

    if (itemType === "bgColor") {
      handleApi();
    }
  };



  const handleApi = async () => {
    toggleDrawer(false);
    try {
      const token = localStorage.getItem("token");
        if (token) {
          setAuthHeader(token);
        }
      const response = await axios.post(
      `${apiURL}admin/layout`,
      {
        ...headerItemData,
      },
      {
        headers: {
        "Content-Type": "application/json",
        },
      }
      );

      const data = response.data;
      // console.log("ddtt",{ data });
    } catch (error) {
      console.error("err",error);
    }
  };


  // Function to determine the initial color based on item properties
  const getInitialColor = (editItem, isMobile, headerItemData) => {
    let initialColor;

    const { prevItem, key, index } = editItem;
    const { customHeader } = headerItemData;

    // Handle search or items as prevItem
    if (prevItem === "search" || prevItem === "items") {
      if (isMobile) {
        if (prevItem === "search") {
          initialColor =
            customHeader.customHeader.customizeHeader["mobileSearch"][key];
        } else if (prevItem === "items") {
          initialColor =
            customHeader.customHeader.customizeHeader["mobileItems"][key];
        }
      } else {
        initialColor = customHeader.customHeader.customizeHeader[prevItem][key];
      }
      return initialColor;
    }

    // Handle non-mobile case where prevItem isn't "search" or "items"
    if (!isMobile) {
      if (prevItem === "test") {
        const headerType =
          index === 0
            ? "customTopbar"
            : index === 1
            ? "customHeader"
            : "customNavbar";
        initialColor = customHeader[headerType].backgroundColor;
        return initialColor;
      }

      initialColor = customHeader.customTopbar.links[index][prevItem][key];
      return initialColor;
    }

    // Handle mobile case
    if (prevItem !== "test") {
      initialColor = customHeader.mobileTopbar.links[index][prevItem][key];
      return initialColor;
    }

    // Handle case where prevItem is "test" on mobile
    const headerType = index === 0 ? "mobileTopbar" : "mobileHeader";
    initialColor = customHeader[headerType].backgroundColor;

    return initialColor;
  };

  const renderDrawerContent = () => {
    // eslint-disable-next-line default-case
    switch (editItem.item) {
      case "action":
        return (
          <ActionMenu
            toggleDrawer={toggleDrawer}
            editItem={editItem}
            handleSave={handleSave}
            headerItemData={headerItemData}
            handleApi={handleApi}
            isMobile={isMobile}
          />
        );
      case "test":
        return (
          <EditHeader
            toggleDrawer={toggleDrawer}
            editItem={editItem}
            handleSave={handleSave}
            headerItemData={headerItemData}
            handleApi={handleApi}
            isMobile={isMobile}
          />
        );
      case "design":
        return (
          <DesignMenu
            toggleDrawer={toggleDrawer}
            editItem={editItem}
            headerItemData={headerItemData}
            handleSave={handleSave}
            handleApi={handleApi}
            isMobile={isMobile}
          />
        );

      case "content":
        return (
          <ContentMenu
            toggleDrawer={toggleDrawer}
            editItem={editItem}
            handleSave={handleSave}
            headerItemData={headerItemData}
            handleApi={handleApi}
            isMobile={isMobile}
          />
        );
      case "picker":
        let initialColor = getInitialColor(editItem, isMobile, headerItemData);
        // console.log({ initialColor });

        // if (editItem.prevItem === "search" || editItem.prevItem === "items") {
        //   if (isMobile && editItem.prevItem === "search") {
        //     initialColor =
        //       headerItemData.customHeader.customHeader.customizeHeader[
        //         "mobileSearch"
        //       ][editItem.key];
        //   } else if (isMobile && editItem.prevItem === "items") {
        //     initialColor =
        //       headerItemData.customHeader.customHeader.customizeHeader[
        //         "mobileItems"
        //       ][editItem.key];
        //   } else {
        //     initialColor =
        //       headerItemData.customHeader.customHeader.customizeHeader[
        //         editItem.prevItem
        //       ][editItem.key];
        //   }
        // } else {
        //   if (isMobile && editItem.prevItem !== "test") {
        //     initialColor =
        //       headerItemData.customHeader.mobileTopbar.links[editItem.index][
        //         editItem.prevItem
        //       ][editItem.key];
        //   } else {
        //     if (editItem.prevItem === "test") {
        //       if (isMobile) {
        //         let headerType =
        //           editItem.index === 0 ? "mobileTopbar" : "mobileHeader";
        //         initialColor =
        //           headerItemData.customHeader[headerType].backgroundColor;
        //       } else {
        //         let headerType = "customNavbar";
        //         if (editItem.index === 0) {
        //           headerType = "customTopbar";
        //         } else if (editItem.index === 1) {
        //           headerType = "customHeader";
        //         }
        //         console.log({ headerType });
        //         initialColor =
        //           headerItemData.customHeader[headerType].backgroundColor;
        //       }
        //     } else {
        //       initialColor =
        //         headerItemData.customHeader.customTopbar.links[editItem.index][
        //           editItem.prevItem
        //         ][editItem.key];
        //     }
        //   }
        // }

        return (
          <ColorPicker
            toggleDrawer={toggleDrawer}
            editItem={editItem}
            handleSave={handleSave}
            initialColor={initialColor}
          />
        );
      case "customizeHeader":
        return (
          <CustomizeHeader
            toggleDrawer={toggleDrawer}
            editItem={editItem}
            isMobile={isMobile}
          />
        );
      case "search":
        return (
          <HeaderColorMenu
            toggleDrawer={toggleDrawer}
            editItem={editItem}
            headerItemData={headerItemData}
            isMobile={isMobile}
            handleApi={handleApi}
          />
        );
      case "items":
        return (
          <HeaderColorMenu
            toggleDrawer={toggleDrawer}
            editItem={editItem}
            headerItemData={headerItemData}
            isMobile={isMobile}
            handleApi={handleApi}
          />
        );
      case "menu":
        return <Menu toggleDrawer={toggleDrawer} editItem={editItem} />;
      // Add cases for other menu types as needed
      case "shadowGenerator":
        return (
          <BoxShadowGenerator
            toggleDrawer={toggleDrawer}
            editItem={editItem}
            handleSave={handleSave}
            headerItemData={headerItemData}
            handleApi={handleApi}
          />
        );
    }
  };

  const CustomDrawer = (
    <Drawer
      open={
        editItem.open &&
        editItem.item !== null &&
        editItem.item !== "bgColor" &&
        editItem.item !== "logo"
      }
      onClose={() => toggleDrawer(false)}
      anchor="right"
      PaperProps={{
        sx: {
          height: "auto",
          width: "370px",
          paddingBottom: "20px",
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          height: "100%",
          width: "100%",
        }}
      >
        {renderDrawerContent()}
      </Box>
    </Drawer>
  );

  return !isMobile ? (
    <>
      <div>
        {headerItemData !== null && (
          <Header
            toggleDrawer={toggleDrawer}
            headerItemData={headerItemData}
            setHeaderItemData={setHeaderItemData}
            editItem={editItem}
            handleSave={handleSave}
            handleApi={handleApi}
            setIsMobile={setIsMobile}
            isMobile={isMobile}
          />
        )}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          minWidth: "100%",
          padding: "20px",
        }}
      >
        {CustomDrawer}
      </div>
    </>
  ) : (
    <>
      <MobileHeader
        toggleDrawer={toggleDrawer}
        headerItemData={headerItemData}
        setHeaderItemData={setHeaderItemData}
        editItem={editItem}
        handleSave={handleSave}
        handleApi={handleApi}
        setIsMobile={setIsMobile}
        isMobile={isMobile}
      />
      {CustomDrawer}
    </>
  );
};

export default CustomHeader;
